/** Figma sidebar nav / agent icons — 25px, Grey/950 · dark: Base/White */
export const SIDEBAR_NAV_ICON_SIZE = 25;
export const SIDEBAR_NAV_ICON_STROKE = 1.75;

export const sidebarNavIconClass =
  'shrink-0 text-grey-950 dark:text-true-white';

/** Figma primary rail (9062:223133) — Grey/900 #3D3D3D, white in dark mode. */
export const sidebarRailIconClass =
  'shrink-0 text-grey-900 dark:text-true-white';
